module.exports = __webpack_public_path__ + "img/undraw_Selecting_team.b847631b.svg";